import { makeAutoObservable} from "mobx";
import { Auth } from 'aws-amplify';
import history from '../authentication/History';
import environment from '../environments';

class TermsStore {
  constructor() {
    makeAutoObservable(this);
  }

  currentTerms = "";

  getCurrentTerms() {
    Auth.currentSession()
      .then((token) => {
        fetch(environment.API_HOST + "/terms", {
          method: 'GET',
          headers: {
            "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
          }
        })
          .then((response) => response.json())
          .then((json) => {
            var language = navigator.language || navigator.userLanguage;
            language = language.split("-")[0]

            if (json.data[0]["terms_" + language]) {
              this.currentTerms = json.data[0]["terms_" + language]
            } else {
              this.currentTerms = json.data[0]["terms_de"]
            }
          })
          .catch((error) => {
            console.log(error);
          })
      })
      .catch((error) => {
        console.log(error);
        return error;
      })
  }

  acceptCurrentTerms() {
    Auth.currentSession()
      .then((token) => {
        fetch(environment.API_HOST + "/terms/accept", {
          method: 'POST',
          headers: {
            "Authorization": "Bearer " + token.getAccessToken().getJwtToken(),
          }
        })
          .then((response) => response.json())
          .then((json) => {
            history.push('/stickers')
          })
          .catch((error) => {
            console.log(error);
          })
      })
      .catch((error) => {
        console.log(error);
        return error;
      })
  }
}

const termsStore = new TermsStore();
export default termsStore;